import React from 'react';
import { Load } from './styles'

const Loader:React.FC = () => ( <Load><div></div></Load> );

export default Loader;